import angular from 'angular';
import uiRouter from 'angular-ui-router';
import clientsComponent from './clients.component';
import dataTable from 'angular-material-data-table';

let clientsModule = angular.module('clients', [
    uiRouter,
    dataTable
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider
    .state('clients', {
        url: '/clients',
        component: 'clients',
        parent: 'main',
        data: {
            permissions: {
                only: ['OPERATOR'],
                redirectTo: 'home'
            }
        },
        resolve: {
            clients: ClientsService => {
                return ClientsService.find();
            }
        }
    });
})
.component('clients', clientsComponent)
.name;

export default clientsModule;
